import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { generateMockVisitorGroup } from './visitorGroup';

// Group `type` drives three separate behaviours, so every group below sets one explicitly:
//   - INSTALLERS                     -> the `installer` role filter (isVisitorHasInstallerRole)
//   - ADMINISTRATORS / ATLAS_INTERNAL / INSTALLERS
//                                     -> hidden from the Groups column and ignored by `noGroup`
//                                       (getVisibleVisitorGroupMemberships), but still searchable
//   - AZURE_AD / CO_CONTRACTORS       -> group origin (EntraId / Atlas) on the User groups tab

export const mockVisitorGroupInstallers = generateMockVisitorGroup({
  id: 'mockedIdInstallers',
  name: 'Installers',
  type: VisitorGroupType.Installers
});
export const mockVisitorGroupCleaners = generateMockVisitorGroup({
  id: 'mockedIdCleaners',
  name: 'Cleaning Crew',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupCognitoTeam = generateMockVisitorGroup({
  id: 'mockedIdCognitoTeam',
  name: 'Cognito Team',
  type: VisitorGroupType.ExternalVisitors
});
export const mockVisitorGroupInternalTeam = generateMockVisitorGroup({
  id: 'mockedIdInternalTeam',
  name: 'Internal Team',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupKeySharingUsers = generateMockVisitorGroup({
  id: 'mockedIdKeySharingUsers',
  name: 'Key Sharing Users',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupEntraTeam = generateMockVisitorGroup({
  id: 'mockedIdEntraTeam',
  name: 'Entra Team',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupCardHolders = generateMockVisitorGroup({
  id: 'mockedIdCardHolders',
  name: 'Card Holders',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupCoContractors = generateMockVisitorGroup({
  id: 'mockedIdCo-contractors',
  name: 'Co-contractors',
  type: VisitorGroupType.CoContractors
});

export const mockVisitorGroupAlpha = generateMockVisitorGroup({
  id: 'mockGroupAlpha',
  name: 'Alpha Team',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupBeta = generateMockVisitorGroup({
  id: 'mockGroupBeta',
  name: 'Beta Squad',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupGamma = generateMockVisitorGroup({
  id: 'mockGroupGamma',
  name: 'Gamma Force',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupDelta = generateMockVisitorGroup({
  id: 'mockGroupDelta',
  name: 'Delta Crew',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupEpsilon = generateMockVisitorGroup({
  id: 'mockGroupEpsilon',
  name: 'Epsilon Unit',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupZeta = generateMockVisitorGroup({
  id: 'mockGroupZeta',
  name: 'Zeta Group',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupEta = generateMockVisitorGroup({
  id: 'mockGroupEta',
  name: 'Eta Division',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupTheta = generateMockVisitorGroup({
  id: 'mockGroupTheta',
  name: 'Theta Corp',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupIota = generateMockVisitorGroup({
  id: 'mockGroupIota',
  name: 'Iota Team',
  type: VisitorGroupType.AzureAd
});

// Hidden groups — membership in one of these does NOT count as "having a group".
// `mockVisitor20Inactive` is a member of Administrators only, so it must still match the
// `noGroup` filter; `mockVisitor12WithBlockedCard` pairs a visible group with Atlas Internal,
// so the Groups column shows one chip while search still matches "Atlas Internal".
export const mockVisitorGroupKappa = generateMockVisitorGroup({
  id: 'mockGroupKappa',
  name: 'Atlas Internal',
  type: VisitorGroupType.AtlasInternal
});
export const mockVisitorGroupLambda = generateMockVisitorGroup({
  id: 'mockGroupLambda',
  name: 'Administrators',
  type: VisitorGroupType.Administrators
});

export const mockVisitorGroupMu = generateMockVisitorGroup({
  id: 'mockGroupMu',
  name: 'Mu Collective',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupNu = generateMockVisitorGroup({
  id: 'mockGroupNu',
  name: 'Nu Alliance',
  type: VisitorGroupType.AzureAd
});
export const mockVisitorGroupXi = generateMockVisitorGroup({
  id: 'mockGroupXi',
  name: 'Xi Brigade',
  type: VisitorGroupType.CoContractors
});
export const mockVisitorGroupOmicron = generateMockVisitorGroup({
  id: 'mockGroupOmicron',
  name: 'Omicron Labs',
  type: VisitorGroupType.AzureAd
});

// Visitors created without an explicit `visitorGroupMembership` fall back to this default
// (see generateMockVisitor / generateMockVisitorGroupMembership) — it must be included below too.
export const mockVisitorGroupDefault = generateMockVisitorGroup({});

// Must include every group referenced by any visitor's visitorGroupMembership in visitorFixtures.ts —
// this backs the "all groups" warmup query that fills in the `name` field in the Apollo cache for the
// composed cache-only visitors query. A group missing here resolves with `name: undefined` at runtime.
export const mockVisitorGroupsInstallersAndCleaners = [
  mockVisitorGroupInstallers,
  mockVisitorGroupCleaners,
  mockVisitorGroupCoContractors,
  mockVisitorGroupCognitoTeam,
  mockVisitorGroupInternalTeam,
  mockVisitorGroupKeySharingUsers,
  mockVisitorGroupEntraTeam,
  mockVisitorGroupCardHolders,
  mockVisitorGroupAlpha,
  mockVisitorGroupBeta,
  mockVisitorGroupGamma,
  mockVisitorGroupDelta,
  mockVisitorGroupEpsilon,
  mockVisitorGroupZeta,
  mockVisitorGroupEta,
  mockVisitorGroupTheta,
  mockVisitorGroupIota,
  mockVisitorGroupKappa,
  mockVisitorGroupLambda,
  mockVisitorGroupMu,
  mockVisitorGroupNu,
  mockVisitorGroupXi,
  mockVisitorGroupOmicron,
  mockVisitorGroupDefault
];
